<template>
    <div class="d-flex flex-column justify-content-center gap-3">
      <div>
      <slot :paginated-items="paginatedItems" text="123" ></slot>
      </div>
      <ul class="pagination d-flex justify-content-center" v-if="totalPages > 1">
        <li
          class="page-link"
          :class="{ disabled: currentPage === 1 }"
          @click="changePage(currentPage - 1)"
        >
          Anterior
        </li>
        <li class="page-link">{{ currentPage }} de {{ totalPages }}</li>
        <li
          class="page-link"
          :class="{ disabled: currentPage === totalPages }"
          @click="changePage(currentPage + 1)"
        >
          Próxima
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
      reversed: {
        type: Boolean,
        default: false
      },
      itemsPerPage: {
        type: Number,
        default: 5,
      },
      initialPage: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        currentPage: this.initialPage,
      };
    },
    computed: {
      totalPages() {
        if(!this.items){
          return 0
        }
        return Math.ceil(this.items.length / this.itemsPerPage);
      },
      paginatedItems() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.sortedItems.slice(start, end);
      },
      sortedItems() {
        if(!this.items){
          return []
        }

        if(this.reversed){
          return this.items.slice(0).reverse()
        }

        return this.items;
      },
    },
    watch: {
      totalPages(newTotalPages) {
        if (this.currentPage > newTotalPages && newTotalPages > 0) {
          this.currentPage = newTotalPages;
        }
        
        if (newTotalPages === 0) {
          this.currentPage = 1;
        }
      }
    },
    methods: {
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.currentPage = page;
        }
      },
    },
  };
  </script>
  
  <style>
  .pagination .disabled {
    pointer-events: none;
    color: #ccc;
  }

  .pagination li{
    cursor: pointer;
  }
  </style>
  